<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">Capítulos y Subcapítulos</span>
  <button mat-icon-button (click)="closeDialogCapitulosApu()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card style="background-color: whitesmoke; height: 100% !important;">
  <mat-card-content style="padding-top: 1rem; height: 100%;">
    <div class="mat-elevation-z4 div-ajusted" style="overflow: auto; margin-bottom: 10px; height: 100%; width: 100%;">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
        <mat-form-field appearance="outline">
        <mat-label> Filtro Específico </mat-label>
        <mat-select [formControl]="filterDetails" (selectionChange)="cleanFilter()"
          matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
          <mat-option value="0">Seleccione...</mat-option>
          <mat-option value="reference" matTooltip="Filtro por la columna Referencia"
            matTooltipPosition="right">Referencia
          </mat-option>
          <mat-option value="description" matTooltip="Filtro por la columna Descripción"
            matTooltipPosition="right">Descripción
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width-30vw" floatLabel="always"
        matTooltip="Valor a filtrar por columna seleccionada" matTooltipPosition="above">
        <mat-label> Valor </mat-label>
        <input matInput placeholder="Valor a filtrar..." [formControl]="descriptionFilter"
          (keyup)="applyFilterDetails($event)" #input2>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Nro de Registros</mat-label>
        <input matInput disabled="true" [value]="nroRegistros">
      </mat-form-field>
    </div>
    <table mat-table [dataSource]="dataSourceFilters" matSort matSortActive="reference" matSortDirection="asc">
      <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
        <td mat-cell align="center" *matCellDef="let element"> {{element.reference}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: false" class="mat-header-medium"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
        [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}" (mouseover)="row.hovered = true"
        (mouseout)="row.hovered = false"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="11">No hay data que filtrar</td>
      </tr>
    </table>
  </div>
</mat-card-content>
<mat-card-actions>
  <div class="mat-card-cvr" fxLayoutGap="20px">
    <button mat-raised-button color="warn" type="button" (click)="closeDialogCapitulosApu()"
      class="align-center-middle">
      <span class="text-icon-space">Regresar</span>
      <mat-icon>restart_alt</mat-icon>
    </button>
    <button mat-raised-button color="primary" type="button" (click)="aplicarCapituloPartidas()"
      class="align-center-middle">
      <span class="text-icon-space">Capturar</span>
      <mat-icon>save</mat-icon>
    </button>
  </div>
</mat-card-actions>
</mat-card>